import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=e5f32d8c&scoped=true&"
import script from "./TheSidebar.vue?vue&type=script&lang=js&"
export * from "./TheSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=e5f32d8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f32d8c",
  null
  
)

export default component.exports